/**
 * VideoPlayer component constants
 */

export const VIDEO_PLAYER_CONSTANTS = {
  // Default values
  DEFAULT_TEST_ID: 'video-player',
  DEFAULT_AUTOPLAY_DELAY: 100, // ms

  // CSS classes
  DEFAULT_WRAPPER_CLASSES: 'aspect-video w-full relative',
  DEFAULT_PLAYER_CLASSES: 'w-full h-full',
  ROUNDED_WRAPPER_CLASSES: 'rounded-lg overflow-hidden [&_*]:rounded-lg bg-black',

  // ReactPlayer defaults
  REACT_PLAYER_WIDTH: '100%',
  REACT_PLAYER_HEIGHT: '100%',

  // Video preview defaults
  PREVIEW_DEFAULT_CLASSES: {
    wrapper: 'absolute w-full h-full inset-0 cursor-pointer transition-opacity duration-450 ease-in-out',
    blur: 'absolute inset-0 w-full h-full',
    image: 'w-full h-full bg-cover bg-center',
    portraitOverlay:
      'absolute inset-0 w-full h-full before:absolute before:bottom-0 before:left-0 before:right-0 before:bg-black/40 before:bg-none before:h-full',
    overlay:
      'absolute inset-0 w-full h-full before:absolute before:bottom-0 before:left-0 before:right-0 before:h-2/3 before:bg-gradient-to-t before:from-gray-800 before:to-transparent',
    label: 'absolute text-white font-[670] font-sans text-2xl bottom-4 left-6',
  },

  //   Contentful values
  PORTRAIT_ASPECT_RATIO: 0.5625,
} as const;
